import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { newsEdit, newsUpdate } from '../../../store/actions/websiteActions'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Upload, message } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import MyCustomUploadAdapterPlugin from '../../../components/UploadFileCK'
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import './suneditor.css'


const NewsEdit = () => {
  const [type, settype] = useState('')
  const [title, settitle] = useState('')
  const [intro, setintro] = useState('')
  const [publishdate, setpublishdate] = useState('')
  const [status, setstatus] = useState('')
  const [content, setcontent] = useState('')
  const [contentplain, setcontentplain] = useState('')
  const [file, setfile] = useState([])
  const [image, setimage] = useState()
  const [isWaButton, setIsWaButton] = useState(false)
  const [loading, setloading] = useState(false)

  let dispatch = useDispatch()
  let history = useHistory()
  const id = localStorage.getItem('id_news');

  useEffect(() => {
    dispatch(newsEdit(id))
  }, [dispatch, id])

  const datanewsUpdate = useSelector(state => state.newsUpdate)
  const { validation } = datanewsUpdate

  const dataLogin = useSelector(state => state.login)
  const { userInfo } = dataLogin
  const updated_by = userInfo.user.id

  const datanewsEdit = useSelector(state => state.newsEdit)
  const { news } = datanewsEdit

  useEffect(() => {
    if (news) {
      settype(news.type)
      settitle(news.title)
      setintro(news.intro)
      setpublishdate(news.publish_time)
      setstatus(news.active)
      setcontent(news.content)
      setcontentplain(news.content_plain)
      setIsWaButton(news.whatsapp_button_enable)
      setimage(process.env.REACT_APP_IMAGE_LINK + news.image_path)
    }
  }, [news])

    useEffect(() => {
          if (!userInfo || !userInfo.permission) return;
    if (userInfo.user.roles[0].name == "Super Admin") return;
      if (!userInfo.permission.includes("news-edit")) window.location.href = process.env.REACT_APP_LINK_REDIRECT + "403";
    }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const styledContent = addInlineStyle(content);
    dispatch(newsUpdate(type, title, intro, styledContent, contentplain, publishdate, status, file, updated_by, id, history, isWaButton))
  }

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }
  
  function beforeUpload(file) {
    setloading(true)
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  }

  const handleChange = (info) => {
    setfile(info.file.originFileObj)
    getBase64(info.file.originFileObj, imageUrl =>
      setimage(imageUrl),
      setloading(false)
    );
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  function addInlineStyle(html) {
  let updated = html;

  updated = updated.replace(
    /<table([^>]*)>/g,
    '<table style="border-collapse: collapse; width: 100%; border: 2px dashed rgb(28, 169, 225);"$1>'
  );

  updated = updated.replace(
    /<td([^>]*)>/g,
    '<td style="padding: 5px; border: 1px solid rgb(28, 169, 225);"$1>'
  );

  updated = updated.replace(
    /<tr([^>]*)>([\s\S]*?)<\/tr>/g,
    (match, attrs, inner, offset) => {
      const isFirstRow = offset === updated.indexOf(match);
      if (isFirstRow) {
        return `<tr style="font-weight: bold; background-color: rgba(224, 247, 250, 0.5) ; color: rgb(28, 169, 225);"${attrs}>${inner}</tr>`;
      }
      return `<tr${attrs}>${inner}</tr>`;
    }
  );

  let rowIndex = 0;
  updated = updated.replace(
    /<tr([^>]*)>([\s\S]*?)<\/tr>/g,
    (match, attrs, inner) => {
      rowIndex++;
      if (rowIndex % 2 === 0 && rowIndex !== 1) {
        return `<tr style="background-color:rgba(28, 169, 225, 0.3);"${attrs}>${inner}</tr>`;
      }
      return `<tr${attrs}>${inner}</tr>`;
    }
  );

  return updated;
}


  return (
    <div className="">
      <div className="page-title">
        <div className="title_left">
          <h3>Edit News</h3>
        </div>
      </div>
      <div className="clearfix"></div><br/>
      <div className="row">
        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="x_panel">
            <div className="x_title">
              <h2>Form Input</h2>
              <div className="clearfix"></div>
            </div>
            
            <div className="x_content overflow-auto">  
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="form-group">
                  <label for="name">Type</label>
                  <select 
                    className={ validation.length !== 0 && validation['type'] ? 'form-control parsley-error' : 'form-control' }
                    value={type}
                    required onChange={(e) => settype(e.target.value)}
                  >
                    <option disabled selected value="">Select Type</option>
                    <option value="default">Default</option>
                    <option value="the_pulse">The Pulse</option>
                  </select>
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['type']}</li>
                      </ul>
                    :
                      null
                  }
                </div>

                <div className="form-group">
                  <label for="name">Title</label>
                  <input value={title} type="text" className={ validation.length !== 0 && validation['type'] ? 'form-control parsley-error' : 'form-control' }
                  required onChange={(e) => settitle(e.target.value)} />
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['type']}</li>
                      </ul>
                    :
                      null
                  }
                </div>

                <div className="form-group">
                  <label for="name">Intro</label>
                  <textarea 
                    className={ validation.length !== 0 && validation['intro'] ? 'form-control parsley-error' : 'form-control' } 
                    required
                    value={intro}
                    onChange={(e) => setintro(e.target.value)}
                  >
                    {intro}
                  </textarea>
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['intro']}</li>
                      </ul>
                    :
                      null
                  }
                </div>

                <div className="form-group">
                  <label for="name">Content</label>
                  {/* <CKEditor
                      editor={ ClassicEditor }
                      data={content}
                      config={{
                        extraPlugins: [ MyCustomUploadAdapterPlugin ],
                        // ckfinder: {
                        //   uploadUrl: '/ckfinder/core/connector/php/connector.php?command=QuickUpload&type=Files&responseType=json'
                        // }
                      }}
                      onChange={ ( event, editor ) => {
                          const data = editor.getData();
                          var plainString = data.replace(/<[^>]+>/g, '');
                          setcontent(data)
                          setcontentplain(plainString)
                          // console.log( { event, editor, data, plainString } );
                      } }
                    /> */}
                    <SunEditor
                      setContents={content}
                      onChange={(e) => {
                          setcontentplain(e.replace(/<[^>]+>/g, ''));
                          setcontent(e)
                        }
                        }
                      height="400px"
                      setOptions={{
                         attributesWhitelist: {
      all: 'style,class',
      table: 'style,class',
      tr: 'style,class',
      td: 'style,class',
      th: 'style,class'
    },
    addTagsWhitelist: 'table,thead,tbody,tr,th,td,style',
                        imageUploadUrl: null,
                        imageGalleryUrl: '',
                        imageFileInput: true,
                        imageUploadHandler: function (files, info, core, uploadHandler) {
                          const reader = new FileReader();
                          reader.onload = () => {
                            uploadHandler({
                              result: [
                                {
                                  url: reader.result,
                                  name: files[0].name
                                }
                              ]
                            });
                          };
                          reader.readAsDataURL(files[0]);
                        },
                        buttonList: [
                          ['undo', 'redo', 'font', 'fontSize', 'formatBlock'],
                          ['bold', 'underline', 'italic', 'strike'],
                          ['fontColor', 'hiliteColor'],
                          ['align', 'list', 'table'],
                          ['link', 'image', 'video'],
                          ['fullScreen', 'showBlocks', 'codeView'],
                        ]
                      }}
                    />
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['content']}</li>
                      </ul>
                    :
                      null
                  }
                </div>

                <div className="row">
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" id="switchCheckDefault" checked={isWaButton} onChange={(e) => setIsWaButton(e.target.checked) }/>
                        <label class="form-check-label" for="switchCheckDefault">Enable Whatsapp Button</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Publish Date</label>
                      <input type="date" 
                        className={ validation.length !== 0 && validation['publish_date'] ? 'form-control parsley-error' : 'form-control' }
                        value={publishdate}
                        onChange={(e) => setpublishdate(e.target.value)}
                      />
                      {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['publish_date']}</li>
                          </ul>
                        :
                          null
                      }
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Status</label>
                      <select 
                        className={ validation.length !== 0 && validation['status'] ? 'form-control parsley-error' : 'form-control' }
                        value={status}
                        required onChange={(e) => setstatus(e.target.value)}
                      >
                        <option disabled selected value="">Select Status</option>
                        <option value="1">Active</option>
                        <option value="0">Deactive</option>
                      </select>
                      {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['status']}</li>
                          </ul>
                        :
                          null
                      }
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label for="name">Image</label>
                  <Upload
                    name="avatar"
                    listType="picture-card"
                    className="avatar-uploader"
                    showUploadList={false}
                    beforeUpload={beforeUpload}
                    onChange={handleChange}
                  >
                    {image ? <img src={image} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                  </Upload>
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['image']}</li>
                      </ul>
                    :
                      null
                  }
                </div>
                <button type="submit" className="btn btn-primary pull-right">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewsEdit
